import styled, { createGlobalStyle } from "styled-components";

import StakeBg from '@/static/images/stake-bg.png'
import StakeBg2 from '@/static/images/stake-bg2.png'
import Watermark from '@/static/images/dmail-watermark.png'

export const Root = styled.div`
  background: url(${StakeBg}) center top no-repeat;
  background-color: #000;
  background-size: 1330px 549px;
  padding-top: 158px;
  color: #fff;

  &.mobile {
    padding-top: 90px;
    background-size: 150%;

    .filled-red {
      height: 30px;
      padding: 0 12px;
      font-size: 12px;
    }

    .content {
      background-size: contain;
      padding-top: 0;

      h1 {
        padding: 0 20px;
        line-height: 22px;
        font-size: 18px;
      }

      h2 {
        padding: 0 20px;
        margin-top: 15px;
        line-height: 36px;
        font-size: 30px;

        strong {
          margin: 0 10px;
        }
      }

      .desc {
        padding: 0 20px;
        margin-top: 25px;
        line-height: 16px;
        font-size: 12px;
      }
    }

    .bottom {
      padding-top: 25px;

      .center {
        margin: 0;
      }

      footer.center {
        margin-top: 20px;
      }
    }

    .center {
      width: auto;
      margin: 0 15px;
    }

    .total-staked {
      margin-top: 35px;

      h3 {
        font-size: 14px;
        font-weight: bold;
      }

      .staked-num {
        margin-top: 15px;
        font-size: 16px;
        font-weight: bold;

        img {
          margin-right: 8px;
        }
      }
    }

    .stake-rewards {
      margin-top: 30px;
      padding: 20px 15px;
      border-radius: 20px;
      border: 1px solid #484848;

      .title {
        line-height: 20px;
        font-size: 15px;
      }

      .table {
        margin-top: 15px;
        border-width: 1px;

        .tr {
          height: 40px;
          font-size: 12px;

          &:last-child {
            height: auto;
            padding: 10px 0;
            line-height: 16px;
          }
        }

        .td {
          &:first-child {
            width: 75px;
            padding: 0;
            text-align: center;
          }

          strong {
            font-size: 14px;
          }

          div {
            transform: scale(0.9);
          }
        }
      }

      .actions {
        margin-top: 20px;

        .buy {
          svg {
            margin-right: 8px;
          }

          span {
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }

    .activity {
      margin-top: 0px;
      background: none;
      border: none;
      border-radius: 0;
      
      .tab-list {
        padding: 0;

        ul {
          display: flex;
          flex-direction: column;

          &.reverse {
            flex-direction: column-reverse;
          }
        }

        li {
          display: block;
          margin-top: 30px;
          padding: 20px 15px;
          background: rgba(255,255,255,0.15);
          border: 1px solid #484848;
          border-radius: 20px;

          &.gray {
            color: #999;
          }
        }

        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;

          & > div {
            display: flex;
            align-items: center;

            strong {
              margin: 0 3px 0 5px;
            }
          }

          a {
            line-height: 16px;
            font-size: 12px;
            border-bottom: 1px solid #fff;
            cursor: pointer;

            &:hover {
              color: #E9361B;
              border-bottom-color: #E9361B;
            }
          }
        }

        .title {
          margin: 30px 0 20px;
          width: auto;
          line-height: 20px;
          font-size: 15px;
        }

        .table {
          border-radius: 10px;
          font-size: 12px;

          .fixed-text {
            left: 90px;
            right: 10px;
            bottom: 8px;
            font-size: 12px;
          }

          .tc {

            &:first-child {
              border-left-width: 1px;
            }

            &:last-child {
              border-right-width: 1px;
            }

            .td {
              height: 40px;
              line-height: 40px;

              &:last-child {
                height: 48px;
                line-height: 16px;
                padding-top: 20px;
              }
            }

            .td-value {
              font-size: 14px;

              span {
                font-size: 12px;
              }
            }
          }
        }

        .tips {
          font-size: 12px;
        }

        .actions {
          margin-top: 15px;

          .buy {
            svg {
              margin-right: 8px;
            }

            span {
              font-size: 12px;
              line-height: 16px;
            }
          }
        }
      }
    }

    .common {
      h3 {
        background: linear-gradient(to right, #FFFFFF 0%, #545451 50%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: 24px;
        font-size: 20px;
      }
    }

    .airdrops {
      margin-top: 30px;

      .ended {
        right: -8px;
        top: -18px;
      }

      .airdop-item {
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        padding: 20px 15px;
        border-radius: 10px;
      }

      .airdrop-info {
        flex: auto;
      }

      .detail {
        img, svg {
          margin-right: 15px;
        }

        div {
          display: block;
        }

        strong {
          display: block;
          margin: 0 0 4px 0;
          line-height: 20px;
          font-size: 16px;
        }

        span {
          margin-right: 5px;
          line-height: 20px;
          padding: 0 8px;
          transform: scale(0.84);
        }
      }

      .desc {
        padding: 0;
        margin-top: 20px;
      }

      .more-info {
        margin-top: 22px;
        display: block;

        .item {
          margin: 16px 0 0 0!important;
          display: flex;

          align-items: center;
          justify-content: space-between;
          font-size: 12px;

          div {
            margin-top: 0;
            line-height: 1;

            img {
              margin-right: 8px;
            }

            span {
              font-size: 14px;
              width: 16px;
              height: 16px;
            }
          }
        }
      }

      .tokens {
        width: 100%;
        height: 76px;
        margin-left: 0;
        margin-top: 20px;
        border-radius: 10px 10px 10px 10px;
        flex-direction: row;
        align-items: center;

        p {
          margin: 0 0 0 12px;
          line-height: 24px;
          font-size: 20px;
        }
      }

      .mult-tokens {
        flex-direction: column;

        p {
          margin: 5px 0 0 0;
          line-height: 22px;
          font-size: 16px!important;
        }
      }
    }

    .partners {
      margin-top: 30px;
      padding-bottom: 30px;

      ul {
        margin: 20px 0;
      }

      li {
        &:not(:last-child) {
          margin-bottom: 15px;
        }
      }

      .more {
        font-size: 14px;
      }
    }

    /* .faq {
      margin-top: 30px;
      padding-bottom: 30px;

      h3 {
        line-height: 24px;
        font-size: 20px;
      }

      li {
        padding: 20px 0;

        .question {
          line-height: 20px;
          font-size: 14px;

          i {
            width: 30px;
            height: 30px;
            margin-left: 20px;
            flex-shrink: 0;

            &::before, &::after {
              width: 12px;
              height: 2px;
              margin: -1px 0 0 -6px;
            }
          }
        }

        .answer {
          line-height: 16px;
          font-size: 12px;
          max-width: 100%;

          &::before {
            height: 16px;
          }
        }
      }
    } */
  }

  .content {
    padding-top: 40px;
    background: url(${StakeBg2}) center top no-repeat;
    background-size: 1393px 352px;
    text-align: center;

    h1 {
      line-height: 60px;
      font-size: 36px;
      font-family: Inter-Extra Bold, Inter, Inter;
      display: inline-block;
      background: linear-gradient(to right, #FFFFFF 0%, #545451 100%);
      color: #000;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    h2 {
      margin-top: 20px;
      line-height: 66px;
      font-size: 56px;

      strong {
        margin: 0 15px;
        background: linear-gradient(to right, #D6F8FF 0%, #C082FF 55%, #F2E5EC 100%);
        border-bottom: 1px solid;
        border-image: linear-gradient(81deg, rgba(214, 248, 255, 1), rgba(192, 130, 255, 1), rgba(242, 229, 236, 1)) 1 1;
        color: #000;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        cursor: pointer;
      }
    }

    .desc {
      margin-top: 36px;
      line-height: 20px;
      font-size: 16px;
    }
  }

  .center {
    width: 1200px;
    margin: 0 auto;
  }

  .total-staked {
    margin-top: 80px;

    h3 {
      font-weight: normal;
      color: #999;
      font-size: 24px;
    }

    .staked-num {
      margin-top: 25px;
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 36px;
      color: #FFFFFF;

      img {
        margin-right: 10px;
      }
    }
  }

  .stake-rewards {
    margin-top: 65px;
    padding: 70px 65px 45px;
    background: rgba(255,255,255,0.15);
    border: 1px solid #484848;
    border-radius: 30px 30px 30px 30px;

    .title {
      font-size: 32px;
      line-height: 1;
      font-weight: bold;
      text-align: left;

      /* strong {
        color: #DC3219;
      } */
    }

    .tips {
      display: inline-block;
      position: relative;
      vertical-align: middle;
      margin-left: 4px;
      cursor: pointer;

      &:hover {
        p {
          display: block;
        }
      }

      p {
        display: none;
        content: '';
        position: absolute;
        white-space: nowrap;
        box-sizing: border-box;
        left: 0;
        top: 100%;
        transform: translateX(-100px) translateY(5px);
        background: #808080;
        box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.6);
        padding: 12px;
        line-height: 18px;
        border-radius: 10px;
        font-size: 12px;
        font-weight: normal;
        color: rgb(255, 255, 255);
      }
    }

    .table {
      margin-top: 60px;
      border-radius: 15px;
      border: 2px solid #414141;
      overflow: hidden;

      .tr {
        display: flex;
        align-items: center;
        background: #262626;
        height: 58px;
        
        &:nth-child(odd) {
          background: #414141;
        }
      }

      .td {
        &:not(:first-child) {
          flex: 1;
        }

        &:first-child {
          width: 200px;
          padding-left: 58px;
          text-align: left;
        }

        strong {
          color: #E9361B;
          font-size: 22px;
        }
      }
    }

    .actions {
      margin-top: 45px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .filled-red {
        
      }

      .disabled {
        cursor: default;
        transition: none;
        background: #bcbcbc;

        &:hover {
          background: #bcbcbc;
          transform: none;
          box-shadow: none;
        }
      }

      .buy {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #fff;

        &:hover {
          color: #E9361B;

          span {
            border-bottom-color: #E9361B;
          }
        }

        svg {
          margin-right: 12px;
        }

        span {
          font-size: 18px;
          line-height: 20px;
          border-bottom: 1px solid #fff;
        }
      }
    }
  }

  /* .activity {
    margin-top: 75px;
    background: rgba(255,255,255,0.15);
    border: 1px solid #484848;
    border-radius: 30px 30px 30px 30px;
    display: flex;
    overflow: hidden;

    .tabs {
      background-color: #000;

      li {
        padding: 42px;
        color: #999;
        cursor: pointer;

        div {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          font-weight: bold;
          font-size: 24px;
          
          svg {
            margin-right: 10px;
          }
        }

        p {
          line-height: 24px;
          font-size: 18px;
        }
        .tip {
          font-size: 14px;
        }

        &.on {
          color: #fff;
          background: rgba(255,255,255,0.15);
        }
      }
    }

    .tab-list {
      flex: 1;
      padding: 45px 72px 42px;
      text-align: left;

      li {
        display: none;

        &.on {
          display: block;
        }
      }

      .rules {
        text-align: right;

        a {
          line-height: 24px;
          font-size: 14px;
          border-bottom: 1px solid #fff;
          cursor: pointer;

          &:hover {
            color: #E9361B;
            border-bottom-color: #E9361B;
          }
        }
      }

      .title {
        margin: 35px 0 28px;
        width: 702px;
        line-height: 44px;
        font-size: 34px;
        font-weight: bold;

        strong {
          color: #DC3219;
        }
      }

      .table {
        display: flex;
        align-items: center;
        background: #262626;
        border-radius: 15px;
        overflow: hidden;
        border: 2px solid #414141;
        position: relative;

        .fixed-text {
          position: absolute;
          left: 290px;
          right: 30px;
          bottom: 13px;
          font-size: 14px;
        }

        .tc {
          display: flex;
          flex-direction: column;
          flex: 1;

          .td {
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-weight: bold;

            &:nth-child(odd) {
              background: #414141;
            }

            &:last-child {
              height: 60px;
              line-height: 60px;
            }
          }

          .td-value {
            font-size: 22px;
            color: #E9361B;

            span {
              font-size: 13px;
              font-weight: normal;
              color: #999;
              text-decoration: line-through;
            }
          }
        }
      }

      .tips {
        margin-top: 15px;
        font-size: 14px;
        color: #ccc;

        strong {
          color: #fff;
        }
      }

      .actions {
        margin-top: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .filled-red {
          
        }

        .disabled {
          cursor: default;
          transition: none;
          background: #bcbcbc;

          &:hover {
            background: #bcbcbc;
            transform: none;
            box-shadow: none;
          }
        }

        .buy {
          display: flex;
          align-items: center;
          cursor: pointer;

          &:hover {
            color: #E9361B;

            span {
              border-bottom-color: #E9361B;
            }
          }

          svg {
            margin-right: 12px;
          }

          span {
            font-size: 18px;
            line-height: 20px;
            border-bottom: 1px solid #fff;
          }
        }
      }
    }
  } */

  .common {
    h3 {
      line-height: 50px;
      font-size: 42px;
      background: linear-gradient(to right, #FFFFFF 0%, #545451 30%);
      color: #000;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .airdrops {
    margin-top: 80px;
    text-align: left;

    .airdop-item {
      margin-top: 50px;
      padding: 40px;
      background: rgba(217,217,217,0.14);
      border-radius: 15px 15px 15px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }

    .sub-hub {
      .tokens {
        p {
          font-size: 20px;
        }
      }
    }

    .ended {
      position: absolute;
      right: 26px;
      top: 26px;
      padding: 6px;
      background: #323232;
      border-radius: 20px;

      span {
        display: block;
        padding: 0 12px;
        background: #505050;
        line-height: 26px;
        color: #fff;
        border-radius: 20px;
        font-size: 14px;
      }
    }

    .airdrop-info {
      flex: 1;
    }

    .detail {
      display: flex;
      align-items: center;

      img, svg {
        margin-right: 20px;
      }

      div {
        display: flex;
        align-items: center;
      }

      strong {
        margin-right: 40px;
        font-size: 24px;
      }

      span {
        margin-right: 10px;
        padding: 0 20px;
        background: rgba(0,0,0,0.3);
        border-radius: 19px 19px 19px 19px;
        font-size: 12px;
        color: #999999;
        line-height: 24px;
      }
    }

    .desc {
      margin-top: 20px;
      font-size: 14px;
      line-height: 20px;
    }

    .more-info {
      margin-top: 28px;
      display: flex;

      .item {
        font-size: 14px;

        &:not(:last-child) {
          margin-right: 80px;
        }

        p {
          white-space: nowrap;
          color: #999999;
          line-height: 16px;
        }

        div {
          margin-top: 10px;
          display: flex;
          align-items: center;
          line-height: 24px;
          white-space: nowrap;

          img {
            margin-right: 12px;
          }

          span {
            display: flex;
            align-items: baseline;
            justify-content: center;
            font-size: 20px;
            width: 24px;
            height: 24px;
            line-height: 0.6;
            border-radius: 100%;
            background: #333333;
          }
        }
      }
    }

    .tokens {
      width: 348px;
      height: 192px;
      margin-left: 40px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      background: rgba(0,0,0,0.3);
      border-radius: 15px 15px 15px 15px;
      font-weight: bold;
      flex-shrink: 0;

      p {
        margin-top: 20px;
        font-size: 26px;
      }
    }

    .tokens-thumb {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        margin-right: 118px;
      }

      svg {
        border: 1px solid #fff;
        border-radius: 50%;
      }
    }
  }

  .partners {
    margin-top: 80px;
    padding-bottom: 75px;
    text-align: left;

    ul {
      margin: 60px 0;
    }

    li {
      &:not(:last-child) {
        margin-bottom: 30px;
      }

      img {
        width: 100%;
      }
    }

    .more {
      font-size: 30px;
      font-weight: bold;
      text-align: center;
    }
  }

  /* .faq {
    margin-top: 78px;
    padding-bottom: 100px;
    text-align: left;

    h3 {
      line-height: 50px;
      font-size: 42px;
      background: linear-gradient(to right, #FFFFFF 0%, #545451 5%);
      color: #000;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    li {
      padding: 40px 0 25px;
      border-bottom: 1px solid rgba(255,255,255,0.3);
      cursor: pointer;

      .question {
        display: flex;
        justify-content: space-between;
        line-height: 40px;
        font-size: 20px;

        i {
          width: 40px;
          height: 40px;
          margin-left: 30px;
          border: 1px solid rgba(255,255,255,0.5);
          border-radius: 50%;
          box-sizing: border-box;
          position: relative;

          &::before, &::after {
            content: "";
            width: 16px;
            height: 3px;
            background-color: #848484;
            position: absolute;
            left: 50%;
            top: 50%;
            margin: -1px 0 0 -8px;
            transform-origin: center;
            transition: transform .3s ease-out;
          }

          &::before {
            transition-delay: 0.15s;
            transition-duration: 0.15s;
          }
        }

        &.expand {
          i {
            &::before {
              transform: rotate(90deg);
            }

            &::after {
              transform: rotate(180deg);
              transform-origin: center;
            }
          }
        }
      }

      .answer {
        overflow: hidden;
        line-height: 22px;
        font-size: 14px;
        transition: height .3s ease-out;
        max-width: 80%;

        &::before {
          content: '';
          display: block;
          height: 16px;
        }
      }

      a {
        color: #fff;
        font-weight: bold;
        text-decoration: underline;
      }
    }
  } */

  .bottom {
    padding-top: 50px;
    background-color: #fff;

    footer {
      margin-top: 40px;
    }
  }
`
